import React from 'react';
import FlatButton from 'material-ui/FlatButton';

export const BackButton = props => {
    const { reverseStepper } = props;
    return (
        <FlatButton
            label="Back"
            disableTouchRipple={true}
            disableFocusRipple={true}
            onClick={reverseStepper}
        />
    );
}


// WEBPACK FOOTER //
// ./src/js/components/Form/Buttons/BackButton.jsx